<template>
    <Tooltip placement="top" :offset="[0, 20]" :content="message" :max-width="width">
        <div class="exclusion-message">Segment Excluded</div>
    </Tooltip>
</template>

<script setup lang="ts">
import { Tooltip } from '@opteo/components-next'
defineProps(['message', 'width'])
</script>

<style lang="scss" scoped>
@import '@/assets/css/theme.scss';
@import '@/assets/css/variables.scss';

.exclusion-message {
    @include container;
    @include br-999;
    @include inline-flex;
    @include items-center;
    gap: 0.625rem;
    @include f-9;
    @include fw-500;
    transition:
        transform 0.25s cubic-bezier(0.19, 1, 0.22, 1),
        box-shadow 0.25s cubic-bezier(0.19, 1, 0.22, 1);
    line-height: 1.375rem;
    padding: 7px 18px;
    cursor: default;
    user-select: none;
    @include opteo-medium-gray;
}
</style>
